import { render } from "./dashboard_organizer.vue?vue&type=template&id=16c81175"
import script from "./dashboard_organizer.vue?vue&type=script&lang=js"
export * from "./dashboard_organizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__